export default __webpack_public_path__ + "static/media/filled_star.6b5c49cf.svg";